module.exports = __webpack_public_path__ + "static/img/shop_img04@2x.8b8d48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/shop_img04@2x.png
// module id = /ASR
// module chunks = 174